import template from './formButtons.html';
import { FormButtonsController as controller } from './formButtons.controller';

export const formButtonsComponent = {
  name: 'formButtons',
  restrict: 'E',
  template,
  transclude: {
    left: '?left',
    center: '?center',
    right: '?right',
  },
  controller,
  controllerAs: 'vm',
  bindings: {
    leftCol: '@',
    centerCol: '@',
    rightCol: '@'
  }
};
